"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const utils_1 = require("@osmosys/utils");
// import { ObjectHash } from '@osmosys/utils/dist/object-hash';
exports.useOsmosysObjectHash = (obj, options) => {
    return react_1.useMemo(() => {
        return utils_1.generateOsmosysObjectHash(obj, options);
    }, [JSON.stringify({ obj, options })]);
};
//# sourceMappingURL=useOsmosysObjectHash.js.map